import axios from 'axios';
import { auth, resError } from '@services/Helpers/ServiceInterceptor';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL + '/ApplicationPayoff/',
});

api.interceptors.request.use((config) => auth(config));
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => resError(error)
);

class ApplicationPayoffsGridService {
  constructor() {
    if (!ApplicationPayoffsGridService.instance) {
      ApplicationPayoffsGridService.instance = this;
    }
    return ApplicationPayoffsGridService.instance;
  }

  search = (filters, orderBy, orderDir, p, fields, perPage) => {
    return api.post('/search', {
      filters: Object.keys(filters).length > 0 ? filters : null,
      orderBy,
      orderDir,
      page: p,
      fields: undefined,
      perPage: parseInt(perPage),
    });
  };

  create = (entity) => {
    return api.post('/', entity);
  };

  read = (id) => {
    return api.get('/' + id);
  };

  calculate = (entity) => {
    return api.put('/calculate', entity);
  };

  update = (entity) => {
    return api.put('/', entity);
  };

  simulate = (entity) => {
    return api.put('/simulate', entity);
  };

  delete = (id) => {
    return api.delete('/' + id);
  };

  autoSuggest = (value) => {
    return api.post('/search', { filters: { displayName: value }, perPage: 20, page: 1 });
  };

  sendEmail = (id) => {
    return api.post('/sendemail/' + id);
  };

  generatereport = (id) => {
    return api.get('/generatereport/' + id);
  };

  getfile = (id) => {
    return api.get('/getfile/' + id);
  };

  export = (entity) => {
    return api.post(
      '/export', entity,
      {
        responseType: 'blob',
      }
    );
  };
}

const instance = new ApplicationPayoffsGridService();
Object.freeze(instance);

export default instance;
